import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { ReactComponent as OpusLogo } from 'icons/icon-opus-logo.svg';

import {
  loadSubscriptions,
  removeSubscription,
  selectSubscriptions,
} from 'redux/reducers/subscriptions';
import { RootState } from 'redux/rootReducer';

import {
  PageContent,
  LogoContainer,
  Content,
  LinkToMail,
  Text,
  Button,
  Footer,
} from './PreUnsubscribePage.style';

const PreUnsubscribedPage: React.FC<any> = () => {
  const [subscriptions, isLoading] = useSelector((state: RootState) =>
    selectSubscriptions(state, 'label')
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const [isSubscribed, setSubsciption] = useState<null | boolean>(null);

  useEffect(() => {
    dispatch(loadSubscriptions());
  }, [dispatch]);

  useEffect(() => {
    if (subscriptions && subscriptions.length > 0 && !isLoading) {
      setSubsciption(true);
    }
  }, [subscriptions, isLoading]);

  useEffect(() => {
    isSubscribed &&
      subscriptions &&
      subscriptions.length === 0 &&
      history.push('/');
  }, [isSubscribed, subscriptions, history]);

  const handleUnsubscribe = (): void => {
    if (subscriptions && subscriptions.length > 0 && !isLoading) {
      dispatch(removeSubscription(subscriptions[0].id as number));
    }
  };

  return (
    <PageContent>
      <LogoContainer>
        <OpusLogo />
      </LogoContainer>

      <Content>
        <h2>Unsubscribe Confirmation</h2>
        <Text>
          You are about to unsubscribe from “Weekly Top 25 Tracks” email.
        </Text>
        <Button type="button" onClick={handleUnsubscribe}>
          Unsubscribe
        </Button>
      </Content>

      <Footer>
        <p>
          Contact us at{' '}
          <LinkToMail href="mailto:opus-support@wmg.com">
            opus-support@wmg.com
          </LinkToMail>
        </p>
      </Footer>
    </PageContent>
  );
};

export default PreUnsubscribedPage;
